import React from 'react';
import { useListContext } from 'framework/list';
import FormControlLabel from '@mui/material/FormControlLabel';
import { settingsItemSx, StyledSwitch } from 'framework/ui/layout';
import { useProjectsSettings } from 'domain/shared/project';

const ProjectsArchivedToggler = () => {
  const { setArchivedProjectsVisible, areArchivedProjectsVisible } = useProjectsSettings();
  const { loading } = useListContext();

  const onChangeCallback = (event: any) => {
    setArchivedProjectsVisible(event.target.checked);
  };

  return (
    <FormControlLabel
      sx={settingsItemSx}
      control={
        <StyledSwitch
          color="primary"
          onChange={onChangeCallback}
          checked={areArchivedProjectsVisible}
          dataOn="ON"
          dataOff="OFF"
          disabled={loading}
        />
      }
      label="Show archived projects"
    />
  );
};

export default ProjectsArchivedToggler;
